var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.92 39.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0a74dc;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 4.15,
    cy: 4.15,
    r: 4.15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 21.46,
    cy: 4.15,
    r: 4.15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 38.77,
    cy: 4.15,
    r: 4.15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 4.15,
    cy: 19.97,
    r: 4.15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 21.46,
    cy: 19.97,
    r: 4.15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 38.77,
    cy: 19.97,
    r: 4.15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 4.15,
    cy: 35.78,
    r: 4.15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 21.46,
    cy: 35.78,
    r: 4.15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 38.77,
    cy: 35.78,
    r: 4.15
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.8942e63c2b40c84945ff99792569d667.svg";
export { ForwardRef as ReactComponent };